const geocodeLocation = (address) =>
  new Promise((resolve) => {
    if (!address) return resolve(null);
    if (!window.google?.maps?.Geocoder) return resolve(null);

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK' && results?.[0]) {
        const p = results[0].geometry.location;
        resolve({ lat: p.lat(), lng: p.lng() });
      } else {
        console.error('Geocode failed:', status, results);
        resolve(null);
      }
    });
  });

export default geocodeLocation;
